import React from 'react';
import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseLogo: React.FC<IProps> = ({ className }) => (
    <svg className={className} x="0px" y="0px" viewBox="0 0 160 80">
        <rect fill="#009878" y="0" width="160" height="80" />
        <g>
            <defs>
                <rect x="0.9" y="0.2" width="158.2" height="79.5" />
            </defs>
            <path
                fill="#ffffff"
                d="M108,30.4c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3C107.5,29.1,108,29.7,108,30.4"
            />
            <path
                fill="#ffffff"
                d="M103.9,32.2c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1C103.5,31.2,103.9,31.7,103.9,32.2"
            />
            <path
                fill="#ffffff"
                d="M119.3,30.3c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4
		C118.7,29,119.3,29.6,119.3,30.3"
            />
            <path
                fill="#ffffff"
                d="M121.2,27.1c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4
		C120.6,25.7,121.2,26.3,121.2,27.1"
            />
            <path
                fill="#ffffff"
                d="M112.9,38.3c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4
		C112.3,36.9,112.9,37.5,112.9,38.3"
            />
            <path
                fill="#ffffff"
                d="M116.8,27.6c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4
		C116.2,26.2,116.8,26.8,116.8,27.6"
            />
            <path
                fill="#ffffff"
                d="M112.4,28.7c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3
		C111.8,27.4,112.4,28,112.4,28.7"
            />
            <path
                fill="#ffffff"
                d="M115.4,31.4c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4
		C114.8,30,115.4,30.6,115.4,31.4"
            />
            <path
                fill="#ffffff"
                d="M113.1,33.7c0.6,0.5,0.7,1.3,0.2,1.9c-0.5,0.6-1.3,0.7-1.9,0.2c-0.6-0.5-0.7-1.3-0.2-1.9
		C111.7,33.4,112.6,33.3,113.1,33.7"
            />
            <path
                fill="#ffffff"
                d="M111.2,32.2c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3
		C110.6,30.9,111.2,31.5,111.2,32.2"
            />
            <path
                fill="#ffffff"
                d="M109.9,35.3c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2
		C109.3,34.1,109.9,34.6,109.9,35.3"
            />
            <path
                fill="#ffffff"
                d="M109.3,38.3c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1
		C108.8,37.1,109.3,37.7,109.3,38.3"
            />
            <path
                fill="#ffffff"
                d="M103.5,35.4c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9
		C103.1,34.5,103.5,34.9,103.5,35.4"
            />
            <path
                fill="#ffffff"
                d="M100.4,34.6c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8
		C100,33.8,100.4,34.2,100.4,34.6"
            />
            <path
                fill="#ffffff"
                d="M103.4,38.3c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9
		C103,37.4,103.4,37.8,103.4,38.3"
            />
            <path
                fill="#ffffff"
                d="M106.4,36.8c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1C106,35.9,106.4,36.3,106.4,36.8"
            />
            <path
                fill="#ffffff"
                d="M106.9,33.8c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1
		C106.4,32.7,106.9,33.2,106.9,33.8"
            />
            <path
                fill="#ffffff"
                d="M131.6,30.4c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3
		C132.2,29.1,131.6,29.7,131.6,30.4"
            />
            <path
                fill="#ffffff"
                d="M135.7,32.2c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C136.2,31.2,135.7,31.7,135.7,32.2"
            />
            <path
                fill="#ffffff"
                d="M120.4,30.3c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4C121,29,120.4,29.6,120.4,30.3
		"
            />
            <path
                fill="#ffffff"
                d="M126.8,38.3c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4
		C127.4,36.9,126.8,37.5,126.8,38.3"
            />
            <path
                fill="#ffffff"
                d="M122.9,27.6c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4
		C123.5,26.2,122.9,26.8,122.9,27.6"
            />
            <path
                fill="#ffffff"
                d="M127.2,28.7c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3
		C127.9,27.4,127.2,28,127.2,28.7"
            />
            <path
                fill="#ffffff"
                d="M124.3,31.4c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4
		C124.9,30,124.3,30.6,124.3,31.4"
            />
            <path
                fill="#ffffff"
                d="M126.5,33.7c-0.6,0.5-0.7,1.3-0.2,1.9c0.5,0.6,1.3,0.7,1.9,0.2c0.6-0.5,0.7-1.3,0.2-1.9
		C128,33.4,127.1,33.3,126.5,33.7"
            />
            <path
                fill="#ffffff"
                d="M128.5,32.2c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3
		C129.1,30.9,128.5,31.5,128.5,32.2"
            />
            <path
                fill="#ffffff"
                d="M129.8,35.3c0,0.7,0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2
		C130.3,34.1,129.8,34.6,129.8,35.3"
            />
            <path
                fill="#ffffff"
                d="M130.4,38.3c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1
		C130.9,37.1,130.4,37.7,130.4,38.3"
            />
            <path
                fill="#ffffff"
                d="M136.2,35.4c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9
		C136.6,34.5,136.2,34.9,136.2,35.4"
            />
            <path
                fill="#ffffff"
                d="M139.3,34.6c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8
		C139.7,33.8,139.3,34.2,139.3,34.6"
            />
            <path
                fill="#ffffff"
                d="M136.2,38.3c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9
		C136.6,37.4,136.2,37.8,136.2,38.3"
            />
            <path
                fill="#ffffff"
                d="M133.3,36.8c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1c0-0.5-0.4-1-1-1C133.7,35.9,133.3,36.3,133.3,36.8"
            />
            <path
                fill="#ffffff"
                d="M132.8,33.8c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1
		C133.3,32.7,132.8,33.2,132.8,33.8"
            />
            <path
                fill="#ffffff"
                d="M108,46.2c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3C107.5,47.5,108,46.9,108,46.2"
            />
            <path
                fill="#ffffff"
                d="M103.9,44.3c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1C103.5,45.4,103.9,44.9,103.9,44.3"
            />
            <path
                fill="#ffffff"
                d="M121.2,49.5c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4
		C120.6,50.9,121.2,50.3,121.2,49.5"
            />
            <path
                fill="#ffffff"
                d="M116.8,49c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4
		C116.2,50.4,116.8,49.7,116.8,49"
            />
            <path
                fill="#ffffff"
                d="M112.4,47.9c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3
		C111.8,49.2,112.4,48.6,112.4,47.9"
            />
            <path
                fill="#ffffff"
                d="M113.1,42.8c0.6-0.5,0.7-1.3,0.2-1.9c-0.5-0.6-1.3-0.7-1.9-0.2c-0.6,0.5-0.7,1.3-0.2,1.9
		C111.7,43.2,112.6,43.3,113.1,42.8"
            />
            <path
                fill="#ffffff"
                d="M109.9,41.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.6,1.2,1.2,1.2
		C109.3,42.5,109.9,41.9,109.9,41.2"
            />
            <path
                fill="#ffffff"
                d="M100.4,41.9c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8
		C100,42.7,100.4,42.4,100.4,41.9"
            />
            <path
                fill="#ffffff"
                d="M106.4,39.7c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1C106,40.7,106.4,40.3,106.4,39.7"
            />
            <path
                fill="#ffffff"
                d="M131.6,46.2c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3
		C132.2,47.5,131.6,46.9,131.6,46.2"
            />
            <path
                fill="#ffffff"
                d="M135.7,44.3c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1c0,0.6-0.5,1-1,1C136.2,45.4,135.7,44.9,135.7,44.3"
            />
            <path
                fill="#ffffff"
                d="M122.9,49c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4C123.5,50.4,122.9,49.7,122.9,49
		"
            />
            <path
                fill="#ffffff"
                d="M127.2,47.9c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3
		C127.9,49.2,127.2,48.6,127.2,47.9"
            />
            <path
                fill="#ffffff"
                d="M126.5,42.8c-0.6-0.5-0.7-1.3-0.2-1.9c0.5-0.6,1.3-0.7,1.9-0.2c0.6,0.5,0.7,1.3,0.2,1.9
		C128,43.2,127.1,43.3,126.5,42.8"
            />
            <path
                fill="#ffffff"
                d="M129.8,41.2c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2c0,0.7-0.6,1.2-1.2,1.2
		C130.3,42.5,129.8,41.9,129.8,41.2"
            />
            <path
                fill="#ffffff"
                d="M139.3,41.9c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8
		C139.7,42.7,139.3,42.4,139.3,41.9"
            />
            <path
                fill="#ffffff"
                d="M133.3,39.7c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1C133.7,40.7,133.3,40.3,133.3,39.7"
            />
            <path
                fill="#ffffff"
                d="M100.4,38.3c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8
		C100,37.5,100.4,37.8,100.4,38.3"
            />
            <path
                fill="#ffffff"
                d="M139.3,38.3c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8
		C139.7,37.5,139.3,37.8,139.3,38.3"
            />
            <path
                fill="#F3971F"
                d="M121,33.1c0,0.6-0.5,1.2-1.2,1.2c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2C120.5,31.9,121,32.4,121,33.1"
            />
            <path
                fill="#F3971F"
                d="M117.6,33.4c0.4,0.5,0.3,1.2-0.3,1.6c-0.5,0.4-1.2,0.3-1.6-0.3c-0.4-0.5-0.3-1.2,0.3-1.6
		C116.5,32.8,117.3,32.9,117.6,33.4"
            />
            <path
                fill="#F3971F"
                d="M115.1,35.7c0.6,0.2,0.9,0.9,0.7,1.5c-0.2,0.6-0.9,0.9-1.5,0.7c-0.6-0.2-0.9-0.9-0.7-1.5
		C113.9,35.8,114.5,35.5,115.1,35.7"
            />
            <path
                fill="#F3971F"
                d="M122,33.4c-0.4,0.5-0.3,1.2,0.3,1.6c0.5,0.4,1.2,0.3,1.6-0.3c0.4-0.5,0.3-1.2-0.3-1.6
		C123.1,32.8,122.4,32.9,122,33.4"
            />
            <path
                fill="#F3971F"
                d="M124.5,35.7c-0.6,0.2-0.9,0.9-0.7,1.5c0.2,0.6,0.9,0.9,1.5,0.7c0.6-0.2,0.9-0.9,0.7-1.5
		C125.8,35.8,125.2,35.5,124.5,35.7"
            />
            <path
                fill="#F3971F"
                d="M119.3,46.2c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4
		C118.7,47.6,119.3,47,119.3,46.2"
            />
            <path
                fill="#F3971F"
                d="M115.4,45.2c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4
		C114.8,46.5,115.4,45.9,115.4,45.2"
            />
            <path
                fill="#F3971F"
                d="M111.2,44.3c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3
		C110.6,45.6,111.2,45,111.2,44.3"
            />
            <path
                fill="#F3971F"
                d="M103.5,41.2c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9
		C103.1,42.1,103.5,41.7,103.5,41.2"
            />
            <path
                fill="#F3971F"
                d="M106.9,42.8c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1
		C106.4,43.9,106.9,43.4,106.9,42.8"
            />
            <path
                fill="#F3971F"
                d="M121,43.5c0-0.6-0.5-1.2-1.2-1.2c-0.6,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2C120.5,44.6,121,44.1,121,43.5"
            />
            <path
                fill="#F3971F"
                d="M117.6,43.2c0.4-0.5,0.3-1.2-0.3-1.6c-0.5-0.4-1.2-0.3-1.6,0.3c-0.4,0.5-0.3,1.2,0.3,1.6
		C116.5,43.8,117.3,43.7,117.6,43.2"
            />
            <path
                fill="#F3971F"
                d="M115.1,40.9c0.6-0.2,0.9-0.9,0.7-1.5c-0.2-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-0.9,0.9-0.7,1.5
		C113.9,40.8,114.5,41.1,115.1,40.9"
            />
            <path
                fill="#F3971F"
                d="M120.4,46.2c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4C121,47.6,120.4,47,120.4,46.2
		"
            />
            <path
                fill="#F3971F"
                d="M124.3,45.2c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4
		C124.9,46.5,124.3,45.9,124.3,45.2"
            />
            <path
                fill="#F3971F"
                d="M128.5,44.3c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3
		C129.1,45.6,128.5,45,128.5,44.3"
            />
            <path
                fill="#F3971F"
                d="M136.2,41.2c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9
		C136.6,42.1,136.2,41.7,136.2,41.2"
            />
            <path
                fill="#F3971F"
                d="M132.8,42.8c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1
		C133.3,43.9,132.8,43.4,132.8,42.8"
            />
            <path
                fill="#F3971F"
                d="M122,43.2c-0.4-0.5-0.3-1.2,0.3-1.6c0.5-0.4,1.2-0.3,1.6,0.3c0.4,0.5,0.3,1.2-0.3,1.6
		C123.1,43.8,122.4,43.7,122,43.2"
            />
            <path
                fill="#F3971F"
                d="M124.5,40.9c-0.6-0.2-0.9-0.9-0.7-1.5c0.2-0.6,0.9-0.9,1.5-0.7c0.6,0.2,0.9,0.9,0.7,1.5
		C125.8,40.8,125.2,41.1,124.5,40.9"
            />
            <path
                fill="#ffffff"
                d="M33.9,36.3c-1.2,1.2-3.3,1.4-5.2,1.4l-3.6,0v6.5c0,0.2-0.2,0.4-0.4,0.4h-2.1c-0.2,0-0.4-0.2-0.4-0.4V27.4
		c0-0.2,0.2-0.4,0.4-0.4h7c1.8,0,3.3,0.3,4.3,1.3c0.8,0.8,1.2,2.1,1.2,4C35.2,33.8,34.9,35.3,33.9,36.3 M31.5,29.9
		c-0.6-0.6-1.7-0.7-2.9-0.7h-3.5v6.6l2.6-0.1c1.7-0.1,2.9-0.1,3.7-0.8c0.5-0.5,0.8-1.3,0.8-2.5C32.2,31.1,32,30.3,31.5,29.9"
            />
            <path
                fill="#ffffff"
                d="M47.6,39.2c0,0.2-0.1,0.4-0.4,0.4H39c0,1.2,0.3,1.8,0.9,2.4c0.7,0.6,1.6,0.9,3.1,0.9c1.3,0,2.4-0.3,3.4-0.6
		c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.3,0.3l0.2,1.1c0,0.1,0,0.1,0,0.1c0,0.2-0.1,0.3-0.3,0.3c-0.9,0.4-2.5,0.7-4.2,0.7
		c-4.6,0-6.3-2-6.3-6.5c0-4.3,1.1-6.6,5.7-6.6c2.4,0,3.9,0.7,4.7,1.9c0.7,1.1,0.9,2.6,0.9,4.4C47.6,38.4,47.6,38.8,47.6,39.2
		 M44.7,35.5c-0.4-1.4-1.1-1.8-2.7-1.8c-1.7,0-2.5,0.5-2.8,1.8C39,36.2,39,37,39,37.8h5.9C44.9,37,44.9,36.2,44.7,35.5"
            />
            <path
                fill="#ffffff"
                d="M58.2,44.5c-0.8,0.2-1.9,0.3-3.2,0.3c-2.4,0-5.6-0.2-5.6-4c0-3.1,1.8-3.4,3.9-3.7l4.3-0.7v-0.9
		c0-0.7,0-1.2-0.7-1.5c-0.4-0.2-1-0.2-1.9-0.2c-1.7,0-3.3,0.5-4.1,0.7c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3-0.2l-0.3-1.3
		c0-0.2,0.1-0.4,0.3-0.4c0.7-0.2,2.8-0.8,5.1-0.8c1.7,0,2.8,0.2,3.5,0.6c1.2,0.7,1.3,1.8,1.3,3.1V42C60.3,43.7,59.9,44.1,58.2,44.5
		 M57.7,38.3l-3.6,0.6c-1,0.2-1.9,0.3-1.9,1.9c0,2,1.7,2.2,2.9,2.2c1,0,1.9-0.1,2.6-0.4V38.3z"
            />
            <path
                fill="#ffffff"
                d="M63,34.1c0-1,0.4-1.3,1.4-1.6c1-0.3,2.7-0.6,4.7-0.7c0.3,0,0.5,0,0.5,0.4v1.3c0,0.2,0,0.4-0.3,0.4
		c-1.5,0-2.7,0.1-3.6,0.4v9.9c0,0.2-0.1,0.4-0.4,0.4h-2c-0.2,0-0.4-0.1-0.4-0.4V34.1z"
            />
            <path
                fill="#ffffff"
                d="M76.7,44c0,0.1,0,0.3-0.2,0.4c-0.3,0.1-0.9,0.3-2,0.3c-1.9,0-2.9-1-2.9-2.8V27.5c0-0.3,0.1-0.4,0.4-0.4
		l1.9-0.4h0.1c0.2,0,0.3,0.1,0.3,0.4v14.7c0,0.9,0.5,1,1,1c0.4,0,0.6-0.1,0.9-0.1c0.1,0,0.2,0,0.3,0.2L76.7,44z"
            />
            <path
                fill="#ffffff"
                d="M89,39.2c0,0.2-0.1,0.4-0.4,0.4h-8.2c0,1.2,0.3,1.8,0.9,2.4c0.7,0.6,1.6,0.9,3.1,0.9c1.3,0,2.4-0.3,3.4-0.6
		c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.3,0.3l0.2,1.1c0,0.1,0,0.1,0,0.1c0,0.2-0.1,0.3-0.3,0.3c-0.9,0.4-2.5,0.7-4.2,0.7
		c-4.6,0-6.3-2-6.3-6.5c0-4.3,1.1-6.6,5.7-6.6c2.4,0,3.9,0.7,4.7,1.9c0.7,1.1,0.9,2.6,0.9,4.4C89,38.4,89,38.8,89,39.2 M86.1,35.5
		c-0.4-1.4-1.1-1.8-2.7-1.8c-1.7,0-2.5,0.5-2.8,1.8c-0.2,0.7-0.2,1.5-0.2,2.3h5.9C86.3,37,86.3,36.2,86.1,35.5"
            />
            <path
                fill="#ffffff"
                d="M58.1,53.7c-1.8,0-2.1-1-2.1-2.3c0-1.3,0.2-2.3,2.1-2.3c1.8,0,2.1,1,2.1,2.3C60.2,52.6,60,53.7,58.1,53.7
		 M58.1,49.7c-1,0-1.1,0.6-1.1,1.6c0,1,0,1.6,1.1,1.6c1,0,1.1-0.6,1.1-1.6C59.2,50.3,59.1,49.7,58.1,49.7"
            />
            <path
                fill="#ffffff"
                d="M68.1,53.3c0,0.1,0,0.2-0.1,0.2c-0.2,0.1-0.5,0.2-1,0.2c-0.9,0-1.4-0.4-1.4-1.3v-4.5c0-0.1,0-0.1,0.1-0.1
		l0.7-0.1c0.1,0,0.1,0.1,0.1,0.1v1.4h1.3c0.1,0,0.1,0.1,0.1,0.1v0.5c0,0.1-0.1,0.1-0.1,0.1h-1.3v2.5c0,0.4,0.2,0.5,0.6,0.5
		c0.3,0,0.5-0.1,0.7-0.1c0.1,0,0.1,0,0.1,0.1L68.1,53.3z"
            />
            <path
                fill="#ffffff"
                d="M69.6,53.5h-0.7c-0.1,0-0.1-0.1-0.1-0.1v-4.1c0-0.1,0.1-0.1,0.1-0.1h0.7c0.1,0,0.1,0.1,0.1,0.1v4.1
		C69.7,53.5,69.7,53.5,69.6,53.5"
            />
            <path
                fill="#ffffff"
                d="M74,53.3c0,0.1,0,0.1-0.1,0.1c-0.2,0.1-0.8,0.2-1.4,0.2c-1.6,0-2.1-0.8-2.1-2.3c0-1.6,0.4-2.3,2.1-2.3
		c0.6,0,1.2,0.1,1.4,0.2c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0.1l-0.1,0.4c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0
		c-0.2-0.1-0.6-0.2-1.1-0.2c-0.9,0-1.2,0.4-1.2,1.6c0,1.2,0.3,1.6,1.2,1.6c0.4,0,0.8-0.1,1.1-0.2c0.1,0,0.1,0,0.1,0.1L74,53.3
		C74,53.3,74,53.3,74,53.3"
            />
            <path
                fill="#ffffff"
                d="M75.5,53.5h-0.7c-0.1,0-0.1-0.1-0.1-0.1v-4.1c0-0.1,0.1-0.1,0.1-0.1h0.7c0.1,0,0.1,0.1,0.1,0.1v4.1
		C75.6,53.5,75.6,53.5,75.5,53.5"
            />
            <path
                fill="#ffffff"
                d="M80.4,51.7c0,0.1-0.1,0.2-0.1,0.2h-2.9c0,0.4,0.1,0.6,0.3,0.8c0.2,0.2,0.6,0.3,1.1,0.3c0.5,0,0.9-0.1,1.2-0.2
		c0,0,0,0,0.1,0c0.1,0,0.1,0,0.1,0.1l0.1,0.4c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1c-0.3,0.1-0.9,0.3-1.5,0.3c-1.7,0-2.2-0.7-2.2-2.3
		c0-1.5,0.4-2.3,2-2.3c0.9,0,1.4,0.2,1.7,0.7c0.3,0.4,0.3,0.9,0.3,1.6C80.4,51.4,80.4,51.5,80.4,51.7 M79.3,50.3
		c-0.1-0.5-0.4-0.7-1-0.7c-0.6,0-0.9,0.2-1,0.6c-0.1,0.3-0.1,0.5-0.1,0.8h2.1C79.4,50.9,79.4,50.6,79.3,50.3"
            />
            <path
                fill="#ffffff"
                d="M84.8,53.5h-0.7c-0.1,0-0.1-0.1-0.1-0.1v-3c0-0.5-0.2-0.7-0.7-0.7c-0.5,0-1.1,0.1-1.2,0.2v3.5
		c0,0.1-0.1,0.1-0.1,0.1h-0.7c-0.1,0-0.1-0.1-0.1-0.1v-3.6c0-0.3,0.1-0.4,0.6-0.6c0.4-0.1,1.2-0.2,1.7-0.2c1,0,1.6,0.3,1.6,1.3v3.2
		C84.9,53.5,84.9,53.5,84.8,53.5"
            />
            <path
                fill="#ffffff"
                d="M87.2,53.7c-0.7,0-1.4-0.2-1.5-0.3c0,0-0.1-0.1-0.1-0.1l0.1-0.4c0-0.1,0-0.1,0.1-0.1c0,0,0,0,0.1,0
		c0.1,0,0.7,0.2,1.3,0.2c0.6,0,0.9-0.2,0.9-0.6c0-0.6-0.4-0.6-1-0.7c-0.6-0.1-1.5-0.2-1.5-1.3c0-1.2,1-1.4,1.8-1.4
		c0.7,0,1.2,0.2,1.4,0.2c0.1,0,0.1,0.1,0.1,0.1l-0.1,0.5c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.7-0.1-1.1-0.1c-0.5,0-0.9,0.1-0.9,0.6
		c0,0.5,0.5,0.5,1,0.6c0.7,0.1,1.5,0.2,1.5,1.3C89,53.3,88.2,53.7,87.2,53.7"
            />
            <path
                fill="#ffffff"
                d="M63.1,49c-0.6,0-1.2,0.1-1.7,0.3c-0.4,0.1-0.5,0.3-0.5,0.7v5.2c0,0.1,0.1,0.1,0.2,0.1l0.7-0.1
		c0.1,0,0.1-0.1,0.1-0.2v-0.7V54v-0.5c0.3,0.1,0.7,0.1,1.1,0.1c1.6,0,1.9-0.9,1.9-2.3C64.9,50,64.7,49,63.1,49 M62.8,53
		c-0.5,0-0.9-0.1-0.9-0.1v-3c0.1,0,0.6-0.2,1-0.2c0.7,0,1,0.2,1,1.6C63.9,52.6,63.6,53,62.8,53"
            />
        </g>
    </svg>
);

export const Logo = styled(BaseLogo)``;
